var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemGen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m422 207c-11.046 0-20-8.954-20-20v-87c0-33.084-26.916-60-60-60h-172c-33.084 0-60 26.916-60 60v87c0 11.046-8.954 20-20 20s-20-8.954-20-20v-87c0-55.141 44.86-100 100-100h172c55.14 0 100 44.859 100 100v87c0 11.046-8.954 20-20 20zm70 95c0-33.084-26.916-60-60-60h-352c-33.084 0-60 26.916-60 60s26.916 60 60 60h352c33.084 0 60-26.916 60-60zm-60-20c11.028 0 20 8.972 20 20s-8.972 20-20 20h-352c-11.028 0-20-8.972-20-20s8.972-20 20-20zm-115 170c0-33.084-26.916-60-60-60s-60 26.916-60 60 26.916 60 60 60 60-26.916 60-60zm-40 0c0 11.028-8.972 20-20 20s-20-8.972-20-20 8.972-20 20-20 20 8.972 20 20zm235 0c0-11.046-8.954-20-20-20h-115c-11.046 0-20 8.954-20 20s8.954 20 20 20h115c11.046 0 20-8.954 20-20zm-357 0c0-11.046-8.954-20-20-20h-115c-11.046 0-20 8.954-20 20s8.954 20 20 20h115c11.046 0 20-8.954 20-20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemGen);
export default __webpack_public_path__ + "static/media/tem-gen.1d4025f6487ed088f60461f9dfd1f660.svg";
export { ForwardRef as ReactComponent };